var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title font-weight-light grey--text text--lighten-1 text-center"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" SOFT BERRY Inc. all rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }